import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { GUIDES } from "@/data/guides";

export default function Guides() {
  return (
    <div className="grain-bg min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <span className="font-mono text-xs uppercase tracking-[0.18em] text-terracotta">State-by-state guides</span>
        <h1 data-testid="guides-title" className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold text-forest-900 max-w-3xl">
          Criminal case guides for every state
        </h1>
        <p className="mt-4 text-ink-700 leading-relaxed max-w-2xl">
          Pick your state to see its courts, speedy trial deadlines, bail and release rules, and the income limits
          most courts use to decide who gets a free public defender.
        </p>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {GUIDES.map((g) => (
            <Link key={g.slug} to={`/guides/${g.slug}`} data-testid={`guide-link-${g.slug}`}
              className="group flex items-center justify-between rounded-2xl border border-parchment-200 bg-white px-5 py-4 hover:border-forest-800 transition-colors">
              <span className="flex items-center gap-3">
                <span className="font-mono text-xs text-terracotta w-6">{g.abbr}</span>
                <span className="font-medium text-forest-900">{g.federal ? "Federal court" : g.name}</span>
              </span>
              <ArrowRight className="h-4 w-4 text-ink-400 group-hover:translate-x-1 group-hover:text-forest-800 transition-transform" />
            </Link>
          ))}
        </div>
        <p className="mt-10 flex items-center gap-2 text-sm text-ink-500">
          <MapPin className="h-4 w-4" /> General information only, not legal advice. Rules change; confirm with a local attorney.
        </p>
      </div>
    </div>
  );
}
